module.exports = __webpack_public_path__ + "img/hero_image_forum.85fe997.jpg";